// extracted by mini-css-extract-plugin
export default {"pdfIframe":"ccy6mq154"};